import { Inject, Injectable } from '@angular/core';

import { BposOddsConverterService } from '@frontend/sports/odds/feature';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { BetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { BetslipV2GolfWinParticipantPick } from '../../../../../core/picks/sport-specific/betslip-v2-golf-picks';
import { BetslipV2OptionMarketXCastRacePick } from '../../../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { BetBuilderPickRequestMapper } from './bet-builder-pick-request-mapper';
import { GroupPickRequestMapper } from './group-pick-request-mapper';
import { IPickRequestFactoryMapper } from './ipick-request-mapper-factory';
import { IPickRequestMapper } from './pick-request.models';
import { V1PickRequestMapper } from './v1-pick-request-mapper';
import { V2GolfWinParticipantPickRequestMapper } from './v2-golf-win-participant-pick-request-mapper';
import { V2OptionMarketPickRequestMapper } from './v2-option-market-pick-request-mapper';
import { V2ParticiantPickRequestMapper } from './v2-participant-pick-request-mapper';

@Injectable()
export class PickRequestMapperFactory implements IPickRequestFactoryMapper {
    messages: IBetslipMessages;

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) private betslipMessageProvider: IBetslipMessagesProviderService,
        private bposOddsConverterService: BposOddsConverterService,
        private userOddsFormatSettingsService: UserOddsFormatSettingsService,
    ) {
        this.messages = this.betslipMessageProvider.getMessages();
    }

    create(pick: BetslipPick): IPickRequestMapper {
        if (BetslipV2GolfWinParticipantPick.isPick(pick)) {
            return new V2GolfWinParticipantPickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService, this.messages);
        }

        if (BetslipV2ParticipantPick.isPick(pick)) {
            return new V2ParticiantPickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService, this.messages);
        }

        if (BetslipBetBuilderPick.isPick(pick)) {
            return new BetBuilderPickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService);
        }

        if (BetslipV2OptionMarketPick.isPick(pick) || BetslipV2OptionMarketXCastRacePick.isPick(pick)) {
            return new V2OptionMarketPickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService, this.messages);
        }

        if (BetslipV1Pick.isPick(pick)) {
            return new V1PickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService);
        }

        if (BetslipGroupPick.isPick(pick)) {
            return new GroupPickRequestMapper(this.bposOddsConverterService, this.userOddsFormatSettingsService, this);
        }

        throw new Error(`no implementation found for this type of pick type: ${pick.constructor.toString()}`);
    }
}
